import React from 'react';
import './header.css';
import { FiArrowRight, FiDownload, FiMapPin } from 'react-icons/fi';
import NodeField from './NodeField';
import SystemDiagram from './SystemDiagram';
import { profile, stats, heroHighlights } from '../../data/profile';
import Resume from '../../data/resume';

const Header = () => (
  <header id="home" className="hero">
    <NodeField />

    <div className="container hero__container">
      <div className="hero__intro">
        <span className="hero__status">
          <span className="hero__status-dot" />
          {profile.availability}
        </span>

        <h1 className="hero__name">
          Fantahun&nbsp;Fekadu
        </h1>

        <h2 className="hero__role">
          I build <span className="text-gradient">production AI systems</span>
          <br />
          and the <span className="text-gradient">distributed backends</span> behind them.
        </h2>

        <p className="hero__lead">
          Lead full-stack developer and AI/ML engineer with{' '}
          <strong>5+ years</strong> shipping software across AI platforms, fintech, payment
          systems and enterprise applications. I take ambiguous requirements to architecture,
          to production and stay on call for what happens next.
        </p>

        <ul className="hero__highlights">
          {heroHighlights.map((item) => (
            <li key={item} className="tag">
              {item}
            </li>
          ))}
        </ul>

        <div className="hero__cta">
          <a href="#contact" className="btn btn-primary">
            Start a conversation
            <FiArrowRight />
          </a>
          <a href={Resume} download className="btn">
            <FiDownload />
            Download résumé
          </a>
        </div>

        <p className="hero__meta">
          <FiMapPin />
          {profile.location} · {profile.timezone} · Remote-first, worldwide
        </p>
      </div>

      <aside className="hero__panel">
        <div className="hero__panel-head">
          <span className="hero__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          <span className="mono">reference-architecture.svg</span>
        </div>
        <SystemDiagram />
        <div className="hero__panel-foot mono">
          <span>provider-agnostic</span>
          <span>·</span>
          <span>event-driven</span>
          <span>·</span>
          <span>observable</span>
        </div>
      </aside>
    </div>

    <div className="container">
      <dl className="hero__stats">
        {stats.map((stat) => (
          <div key={stat.label} className="hero__stat">
            <dt className="hero__stat-value">{stat.value}</dt>
            <dd className="hero__stat-label">{stat.label}</dd>
          </div>
        ))}
      </dl>
    </div>
  </header>
);

export default Header;
